import { BackendResponse } from "../BackendResponse";
import { NextApiParams, withNextApi } from "../nextApiHelpers";

export interface MyProfilesWithDataResponse extends BackendResponse {
  result: Account[];
}

export interface MyProfilesWithDataParameters extends NextApiParams {}

export const myProfilesWithData = withNextApi<
  MyProfilesWithDataResponse,
  MyProfilesWithDataParameters
>("/auth/MyProfilesWithData", {
  method: "GET",
});

export interface Account {
  guid: string;
  id: number;
  concernId: number;
  concernName: string;
  details?: Medarbeider;
}

export interface Medarbeider extends BackendResponse {
  idTyper: number;
  samtykker: SamtykkerForMedarbeider[];
  id: number;
  avtaleKrav: AvtaleKrav;
  fornavn: string;
  etternavn: string;
  arbeidstelefon: string;
  privattelefon: string;
  mobiltelefon: string;
  telefax: string;
  email: string;
  minimumlonn: number;
  typeEnhetLonnper: number;
  typeFunnetgjennom: number;
  typeAvsluttetgrunnetvikar: number;
  typeNasjonalitet: number;
  typeObjektNasjonalitet: TyperFullRow;
  typeKjonn: number;
  typeObjektKjonn: TyperFullRow;
  typeSivilstatus: number;
  typeObjektSivilstatus: TyperFullRow;
  terminFodsel: string | null;
  royker: boolean;
  antallBarn: number;
  personnummer: string;
  bankIdBekreftetDato: string | null;
  typeInternasjonalId: number;
  typeObjektInternasjonalId: TyperFullRow;
  internasjonalId: string;
  fodselsDato: string | null;
  eksternAdresserefa: string;
  stillingsprosent: number;
  skatteprosent: number;
  skattekort: string;
  ikkeOppdaterSkattekort: boolean;
  feriepengeprosent: number;
  frikort: boolean;
  pensjonist: boolean;
  biarbeidsgiver: boolean;
  ansiennitetsjekket: string | null;
  begrensetTillatelsefFemTil: string | null;
  politiattestsjekket: string | null;
  typeSkattekortPeriode: number;
  frikortSaldo: number;
  frikortSaldoOverfort: string | null;
  grensebelopFrikort: number;
  typeSkattekortForskuddsform: number;
  oppsigelsestid: number;
  tilgjengeligFra: string | null;
  erTilgjengelig: string | null;
  erUtilgjengelig: string | null;
  typeVikartype: number;
  idAvtaler: number;
  lederstilling: boolean;
  offentligProfil: boolean;
  offentligProfilDato: string | null;
  flertypeDeltid: string;
  flerIdFylker: string;
  flerIdKommuner: string;
  flerIdProduktpris: string;
  nivaa: number;
  idKontakter: number;
  paarorende: string;
  flertypeVikarrettigheter: string;
  flertypeVikaronsker: string;
  flertypeSjekkliste: string;
  flertypeHelligdagsfri: string;
  linkedin: string;
  facebook: string;
  twitter: string;
  wwwTidspunkt: string | null;
  wwwFeilantall: number;
  wwwFeilTidspunkt: number;
  wwwPaaminnelse: string | null;
  ipAdresse: string;
  ibannr: string;
  swiftkode: string;
  bankkonto: string;
  unntattArbeidsgiveravgift: boolean;
  kontantetaling: boolean;
  utbetalNegativLonn: boolean;
  besoksadresse: string;
  postadresse: string;
  postnummer: string;
  sokPostnummer: string;
  poststed: string;
  land: string;
  spraak: string;
  neiTileTimelister: boolean;
  timelisteMail: string | null;
  handsoffTil: string | null;
  hPRnummer: number;
  hPRoppdatert: string | null;
  idAnsatteHandsoff: number;
  gp1: number;
  gp2: number;
  idKommuner: number;
  idKommunerSkatt: number;
  idOmraader: number;
  idFylker: number;
  nflertypeVikartype: string;
  bildeversjon: number;
  bildeSlettet: boolean;
  idAnsatteRegistrertAv: number;
  idAnsatteEndretAv: number;
  klage: boolean;
  soketter: boolean;
  aktiv: boolean;
  importert: boolean;
  liteFleksibelArbeidstid: boolean;
  sendtResymeDato: string | null;
  endetResymeDato: string | null;
  registrertDato: string | null;
  endretDato: string | null;
  avsluttetDato: string | null;
  externalStatuses: { date: string; status: string }[];
  cvpExtraFieldValues: CvpExtraFieldValue[];
}

export interface SamtykkerForMedarbeider {
  id: number;
  samtykke: string;
  ja: boolean;
}

export interface AvtaleKrav {
  id_avtaler: number[];
  krevPolitiAttest: boolean;
  krevByggeKort: boolean;
  krevVaskeKort: boolean;
}

export interface TyperFullRow {
  id_typer: number;
  id: number;
  flertype_styringskoder: string;
  styringsparameter: number;
  tekstparameter: string;
  typegruppe: string;
  mappenavn: string;
  navn: string;
  haricon: boolean;
  harbanner: boolean;
  harbakgrunn: boolean;
  id_avdelinger__begrenstil: number;
  avsluttetdato: string | null;
}

export interface CvpExtraFieldValue {
  name: string;
  value: string;
}
